import { RouteRecordRaw } from 'vue-router';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';

// 미사용 플랫폼 소개 페이지 라우트 모음
// - 도메인 타겟 가드 없이 requireAuth만 적용
// - 각 플랫폼이 라이선스 미적용 상태일 때 GNB 1depth 클릭 시 진입
export const introRoutes: RouteRecordRaw[] = [
  {
    path: '/infrastructure/intro',
    name: 'infrastructure_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'infrastructure_Intro View',
        component: () => import('@/infrastructure/views/introView/InfrastructureIntroView.vue'),
      },
    ],
  },
  {
    path: '/message-queue/intro',
    name: 'message-queue_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'message-queue_Intro View',
        component: () => import('@/messageQueue/views/introView/MessageQueueIntroView.vue'),
      },
    ],
  },
  {
    path: '/cloud/intro',
    name: 'cloud_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'cloud_Intro View',
        component: () => import('@/cloud/views/introView/CloudIntroView.vue'),
      },
    ],
  },
  {
    path: '/kubernetes/intro',
    name: 'kubernetes_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'kubernetes_Intro View',
        component: () => import('@/kubernetes/views/introView/KubernetesIntroView.vue'),
      },
    ],
  },
  {
    path: '/application/intro',
    name: 'application_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'application_Intro View',
        component: () => import('@/application/views/introView/ApplicationIntroView.vue'),
      },
    ],
  },
  {
    path: '/database/intro',
    name: 'database_Intro',
    beforeEnter: [requireAuth, setDayjsTimezone],
    component: BaseViewport,
    meta: { viewport: VIEWPORT_TYPE.REALTIME },
    children: [
      {
        path: '',
        name: 'database_Intro View',
        component: () => import('@/database/views/introView/DatabaseIntroView.vue'),
      },
    ],
  },
];
